import React, { useMemo, useReducer } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
const InstallContext = /*#__PURE__*/React.createContext(null);
export function InstallationLockProvider(props) {
  function installationReducer(state, action) {
    switch (action.type) {
      case 'set_install_in_progress':
        return {
          installationInProgressAppKey: action.payload.appKey
        };
      case 'clear_install_in_progress':
        return {
          installationInProgressAppKey: null
        };
      case 'installation_success':
        if (props.onInstallSuccess) {
          props.onInstallSuccess({
            installedApp: action.payload.installedApp,
            enableDeprecatedInstallationsGQL: action.payload.enableDeprecatedInstallationsGQL
          });
        }
        return {
          installationInProgressAppKey: null
        };
      default:
        return state;
    }
  }
  const [installationState, dispatch] = useReducer(useMemo(() => installationReducer, [props.onInstallSuccess]), {
    installationInProgressAppKey: null
  });
  return /*#__PURE__*/_jsx(InstallContext.Provider, {
    value: {
      installationState,
      dispatch
    },
    children: props.children
  });
}
export function useInstallationLock() {
  const contextValue = React.useContext(InstallContext);
  if (!contextValue) {
    throw new Error('useInstallationLock must be used from within InstallationLockProvider');
  }
  return contextValue;
}